import { render, staticRenderFns } from "./CustomerGroup.vue?vue&type=template&id=7f7e8bfa&"
import script from "./CustomerGroup.vue?vue&type=script&lang=ts&"
export * from "./CustomerGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports